module.exports = "/assets/data/5753a63977daf5aeae0565f2edf85526-HG4.data.json";